(function () {
  function paintChecks() {
    var scope = document.querySelector("main[data-template^='product']");
    if (!scope) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue.indexOf('\u2713') > -1) nodes.push(walker.currentNode);
    }
    nodes.forEach(function (n) {
      if (n.parentNode && n.parentNode.classList && n.parentNode.classList.contains('dgsf-check')) return;
      var span = document.createElement('span');
      span.innerHTML = n.nodeValue.replace(/\u2713/g, "<span class='dgsf-check'>\u2713</span>");
      n.parentNode.replaceChild(span, n);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintChecks);
  } else {
    paintChecks();
  }
})();
